import * as React from 'react'
import {
  List,
  TextField,
  Datagrid,
  NumberField,
  TextInput,
  useGetIdentity,
  TopToolbar,
  FilterButton,
  ExportButton,
  DateField,
} from 'react-admin'

const FilesFilters = [<TextInput key="campaign_id" source="campaign_id" />]

const DeliveryListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <ExportButton />
    </TopToolbar>
  )
}
const DeliveryList = props => {
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <List
      {...props}
      actions={<DeliveryListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      filters={FilesFilters}
    >
      <Datagrid>
        <NumberField source="userId" />
        <NumberField source="campaign_id" />
        <TextField source="url_envio" />
        <TextField source="respuesta" />
        <DateField
          source="createdAt"
          label="Creation date"
          emptyText="-"
          sortBy="createdAt"
          order="DESC"
        />
      </Datagrid>
    </List>
  )
}

export default DeliveryList
